export const styles = {
  dialogTitle: {
    paddingY: '24px',
    paddingLeft: '24px',
    paddingRight: '12px',
    width: '480px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    width: '24px',
    height: '24px',
  },
  closeButton: {
    minWidth: '40px',
    minHeight: '40px',
    color: 'action.active',
  },
};
